import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Button from '@material-ui/core/Button';
import classnames from 'classnames';
import { Scrollbars } from 'react-custom-scrollbars';
import { Close } from 'components/Icons';
import Empty from 'components/Empty';
import { Status } from '../modules';
import Tooltip from '@material-ui/core/Tooltip';

const Items = ({ mam, classes, selected, deleteExperience, selectExperience }) => {
  if (mam.status === Status.ADDING) {
    return mam.experiences.map(exp => {
      return (
        <div key={exp._id} className={classnames(classes.row, classes.rowDisabled)}>
          <div className={classes.circle} />
          <div className={classes.rowMidDisabled}>{exp.name}</div>
          <div className={classes.rowRight}>
            <Close size={'small'} color={'#bbb'} />
          </div>
        </div>
      );
    });
  }

  if (mam.status === Status.BROWSING) {
    return mam.experiences.map(exp => {
      const isSelected = selected && exp._id === selected._id;

      return (
        <div
          key={exp._id}
          className={classnames(
            classes.row,
            isSelected ? classes.rowSelected : classes.rowHover
          )}
          onClick={() => {
            selectExperience(exp);
          }}
        >
          <div className={classes.circle} />
          <div className={classes.rowMid}>{exp.name} </div>
          {/* {selected.messages.length > 0 && (
            <div className={classes.rowRight}>
              <Tooltip title="Check out the compliance report">
                <ErrorOutline
                  className={
                    hasWarning(exp) ? classes.warningColor : classes.errorColor
                  }
                  style={{ fontSize: '0.9em' }}
                />
              </Tooltip>
            </div>
          )} */}
          <div className={classes.rowRight}>
            <Tooltip title="Delete experience">
              <Close
                size="small"
                color={isSelected ? '#fff' : '#4EA2FF'}
                onClick={() => {
                  deleteExperience(exp.campaign, exp._id, exp.name);
                }}
              />
            </Tooltip>
          </div>
        </div>
      );
    });
  }
};

export const Experience = ({
  classes,
  mam,
  add,
  selected,
  deleteExperience,
  selectExperience,
}) => {
  const isEmpty = mam.status === Status.EMPTY;

  return (
    <div className={classnames(classes.paper, classes.libraryPaper)}>
      <div className={classes.titleContainer}>
        <span className={classes.title}>Experiences</span>
        <Button
          color="primary"
          className={classes.button}
          onClick={add}
          disabled={!selected && !isEmpty}
        >
          +Add
        </Button>
      </div>
      {isEmpty && <Empty message="Empty" minHeight={200} />}
      {!isEmpty && (
        <Scrollbars className={classes.libraryScroll}>
          <Items
            mam={mam}
            selected={selected}
            classes={classes}
            selectExperience={selectExperience}
            deleteExperience={deleteExperience}
          />
        </Scrollbars>
      )}
    </div>
  );
};

Experience.propTypes = {
  classes: PropTypes.object.isRequired,
  mam: PropTypes.object.isRequired,
  add: PropTypes.func.isRequired,
  selected: PropTypes.object,
  deleteExperience: PropTypes.func.isRequired,
  selectExperience: PropTypes.func.isRequired,
};

const styles = theme => ({
  content: {
    backgroundColor: '#F4F8F9',
    flexGrow: 1,
    overflowX: 'hidden',
    overflowY: 'scroll',
    padding: theme.spacing(2),
  },
  paper: {
    padding: 20,
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'nowrap',
    backgroundColor: '#FFFFFF',
    borderRadius: 4,
  },
  libraryPaper: {
    paddingTop: 15,
    paddingRight: 15,
    paddingBottom: 20,
    paddingLeft: 20,
    height: '40vh',
  },
  libraryScroll: {
    marginTop: 5,
    padding: 10,
  },
  titleContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    fontSize: '1em',
    fontWeight: 'bold',
    color: '#000',
  },
  row: {
    display: 'flex',
    padding: 5,
    marginLeft: 5,
    marginRight: 10,
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
  },
  rowDisabled: {
    cursor: 'auto',
  },
  rowHover: {
    '&:hover': {
      backgroundColor: '#bbb',
      color: '#fff',
    },
  },
  rowSelected: {
    backgroundColor: '#4EA2FF',
    color: '#fff',
  },
  rowMid: {
    fontSize: '0.8em',
    flexGrow: 1,
  },
  rowMidDisabled: {
    fontSize: '0.8em',
    flexGrow: 1,
    color: '#bbb',
  },
  rowRight: {},
  circle: {
    borderRadius: '50%',
    width: 7,
    maxWidth: 7,
    minWidth: 7,
    height: 7,
    maxHeight: 7,
    minHeight: 7,
    marginRight: 7,
    marginLeft: 4,
    marginTop: 3,
    backgroundColor: '#7ED321',
  },
  delWhite: {
    '&:hover': {
      color: '#fff',
    },
  },
  delBlue: {
    '&:hover': {
      color: '#4EA2FF',
    },
  },
  warningColor: {
    color: '#F5B041',
    paddingTop: 1,
  },
  errorColor: {
    color: '#C0392B',
    paddingTop: 1,
  },
});

export default withStyles(styles)(Experience);
